/* eslint-disable jsx-a11y/anchor-is-valid */
import {Button, ButtonWrapper, DrawerReport} from '../../../../../../components/UI/Button'
import {FC, useEffect, useState} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {
  getLaundryBillingReportPDF,
  getLaundryBillingReportXLS,
  getLaundryBillingReportCSV,
  getLaundryCostReportCSV,
  getLaundryCostReportPDF,
  getLaundryCostReportXLS,
} from '../../../../services'
import {FormProvider, useForm} from 'react-hook-form'
import {SelectWrapper, InputDateWrapper} from '../../../../../../components/UI/Form/Input'
import {yupResolver} from '@hookform/resolvers/yup'
import {laundryBillingFilter} from '../../../../schema/laundryReport'
import {ModalSaveReport} from '../Modal/ModalSaveReport'
import {useLaundryFilter} from '../../../../hooks/useLaundryFilter'
import {LaundryFilterReportModel} from '../../../../features/laundryBilling/model/laundryBilling.model'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {donwloadFile} from '../../../../helpers/utilities'
import {TableLaundryHystoryWrapper} from './laundryHystory'
import {TableLaundryCostWrapper} from './laundryCost'
import {useCollaborator, useGuest, useTableMaster} from '../../../../hooks'
import {clearFields} from '../../../../../../util/functions'

const downloadReportForType = {
  pdf: getLaundryBillingReportPDF,
  xlsx: getLaundryBillingReportXLS,
  csv: getLaundryBillingReportCSV,
}
const downloadReportCostForType = {
  pdf: getLaundryCostReportPDF,
  xlsx: getLaundryCostReportXLS,
  csv: getLaundryCostReportCSV,
}
type TypeDownloadReport = keyof typeof downloadReportForType
type TypeDownloadReportCost = keyof typeof downloadReportCostForType
type TypeDownloadProps = 'histPesos' | 'ceco'

const TableLaundryGenerateBilling: FC = () => {
  const {isAllowed} = useLavanderia()
  const [formValue, setFormValue] = useState<any>(null)
  const [responseCost, setResponseCost] = useState<boolean>(false)
  const [searching, setIsSearching] = useState<boolean>(false)
  const [isDownload, setIsDownload] = useState<boolean>(false)
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const [detailReport, setDetailReport] = useState<any>({})
  const {
    typeLaundryOrder,
    typeResponsableOrder,
    getTypeResponsableOrderList,
    getTypeLaundryOrderList,
  } = useTableMaster()

  const methods = useForm<LaundryFilterReportModel>({
    resolver: yupResolver(laundryBillingFilter),
  })

  const {setValue, handleSubmit, reset, watch, setError} = methods

  const {client, company, site, getCompanyList, getClientList, getSiteList, handleClearList} =
    useLaundryFilter()
  const {collaborator, getUserCollaboratorList, handleClear} = useCollaborator()
  const {guest, getGuestsServiceList, handleClear: handleCleaGuest} = useGuest()

  const handleDownloadReport = async (
    typeFormat: TypeDownloadReport | TypeDownloadReportCost,
    typeDownload: TypeDownloadProps,
  ) => {
    try {
      setIsDownload(true)
      let data = {}
      if (formValue) {
        data = {
          ...formValue,
          fechaPeriodoInicio: formValue.fechaPeriodoInicio
            ? new Date(formValue.fechaPeriodoInicio)
            : '',
          fechaPeriodoFin: formValue.fechaPeriodoFin ? new Date(formValue.fechaPeriodoFin) : '',
        }
      }
      const response =
        typeDownload === 'histPesos'
          ? await downloadReportForType[typeFormat](data)
          : await downloadReportCostForType[typeFormat](data)
      await donwloadFile(response.data, typeFormat)
      setIsDownload(false)
    } catch (error) {
      setIsDownload(false)
    }
  }

  const onSubmit = (dataForm: LaundryFilterReportModel) => {
    setIsSearching(true)
    setFormValue(dataForm)
    setResponseCost(true)
    setIsSearching(false)
  }

  const handleResetForm = (): void => {
    reset()
    handleClearList()
    setFormValue(null)
    setIsSearching(false)
    getCompanyList()
    handleClear()
    handleCleaGuest()
    setResponseCost(false)
    reset({
      fechaPeriodoInicio: '', // Restablecer manualmente el valor del campo de fecha
      fechaPeriodoFin: '',
    })
  }

  useEffect(() => {
    getCompanyList()
    getTypeResponsableOrderList()
    getTypeLaundryOrderList()
  }, [])

  const handleFilterClient = (e: any) => {
    let value = e.value
    let name = e.label
    getClientList(value)
    setValue('compania', name)
    clearFields(setValue as any, setError as any, {
      cliente: '',
      clienteId: '',
      siteId: '',
      site: '',
      responsableId: '',
    })
    handleClearUsers()
  }

  const handleClearUsers = () => {
    handleClear()
    handleCleaGuest()
  }
  const handleFilterSite = (e: any) => {
    let value = e.value
    let name = e.label
    getSiteList(value)
    setValue('cliente', name)
    clearFields(setValue as any, setError as any, {
      siteId: '',
      site: '',
      responsableId: '',
    })
    handleClearUsers()
  }

  const handleFilterUser = () => {
    let typeResponsable = watch('servicioId') === 'ROPA OPERACIÓN' ? 'COLABORADOR' : 'HUÉSPED'
    let getTypeValue =
      typeResponsableOrder
        .filter((item) => item.value?.toString() === typeResponsable)[0]
        ?.value?.toString() ?? ''
    getUser(getTypeValue)
    setValue('tipoResponsable', getTypeValue)
  }

  const getUser = (type: string) => {
    if (type === 'HUÉSPED') {
      getGuestsServiceList({
        pageNumber: 1,
        size: 100,
        CompaniaId: watch('companiaId'),
        SiteId: watch('siteId'),
      })
    } else {
      getUserCollaboratorList({
        companiaId: watch('companiaId'),
        siteId: watch('siteId'),
      })
    }
  }
  const handleGetSite = (e: any) => {
    let name = e.label
    setValue('site', name)
    if (watch('tipoResponsable')) getUser(watch('tipoResponsable') ?? '')
  }
  const handleGetService = (e: any) => {
    handleFilterUser()
  }
  const handleGetReponsable = (e: any) => {
    let name = e.label
    setValue('responsable', name)
  }
  const convertToString = (value: any) => {
    if (value instanceof Date) {
      return value.toISOString().split('T')[0]
    }
    return value || '' // Asegurar que el valor sea una cadena
  }
  const handleOpenModal = (dataForm: any) => {
    const dateIni = convertToString(watch('fechaPeriodoInicio'))
    const dateFin = convertToString(watch('fechaPeriodoFin'))

    const [yearIni, monthIni, dayIni] = dateIni ? dateIni.split('-') : ['', '', '']
    const [yearFin, monthFin, dayFin] = dateFin ? dateFin.split('-') : ['', '', '']
    let obj = {
      fechaPeriodoInicio: watch('fechaPeriodoInicio')
        ? dayIni + '/' + monthIni + '/' + yearIni
        : '',
      fechaPeriodoFin: watch('fechaPeriodoFin') ? dayFin + '/' + monthFin + '/' + yearFin : '',
      tipoServicio: watch('servicioId'),
      ...watch(),
    }
    setDetailReport(obj)
    setIsOpenModal(true)
    setResponseCost(true)
  }

  const data = [
    {
      text: 'Descargar Hist. de pesos como PDF',
      report: () => handleDownloadReport('pdf', 'histPesos'),
    },
    {
      text: 'Descargar Hist. de pesos como XLSX',
      report: () => handleDownloadReport('xlsx', 'histPesos'),
    },
    {
      text: 'Descargar Hist. de pesos como CSV',
      report: () => handleDownloadReport('csv', 'histPesos'),
    },
    {
      text: 'Descargar CECO como PDF',
      report: () => handleDownloadReport('pdf', 'ceco'),
    },
    {
      text: 'Descargar CECO como XLSX',
      report: () => handleDownloadReport('xlsx', 'ceco'),
    },
    {
      text: 'Descargar CECO como CSV',
      report: () => handleDownloadReport('csv', 'ceco'),
    },
  ]
  let dataUser = watch('servicioId') === 'ROPA OPERACIÓN' ? collaborator : guest
  return (
    <>
      <KTCard shadow className='m-5'>
        {isAllowed('BUSCAR_ENCABEZADO') && (
          <div className='p-8'>
            <FormProvider {...methods}>
              <form>
                <div className='row'>
                  <div className='col-sm-12 col-md-4 col-xl-3'>
                    <SelectWrapper
                      labelText='Compañía'
                      name='companiaId'
                      data={company}
                      onChangeValue={handleFilterClient}
                      required
                    />
                  </div>
                  <div className='col-sm-12 col-md-4 col-xl-3'>
                    <SelectWrapper
                      labelText='Cliente'
                      name='clienteId'
                      data={client}
                      disabled={client.length === 0}
                      onChangeValue={handleFilterSite}
                      required
                    />
                  </div>
                  <div className='col-sm-12 col-md-4 col-xl-3'>
                    <SelectWrapper
                      labelText='Site'
                      name='siteId'
                      data={site}
                      disabled={site.length === 0}
                      onChangeValue={handleGetSite}
                      required
                    />
                  </div>
                  <div className='col-sm-12 col-md-4 col-xl-3'>
                    <SelectWrapper
                      labelText='Tipo de Orden'
                      name='servicioId'
                      data={typeLaundryOrder}
                      onChangeValue={handleGetService}
                    />
                  </div>
                  <div className='col-sm-12 col-md-4 col-xl-3'>
                    <SelectWrapper
                      labelText='Tipo de responsable'
                      name='tipoResponsable'
                      data={typeResponsableOrder}
                      disabled={true}
                    />
                  </div>
                  <div className='col-sm-12 col-md-4 col-xl-3'>
                    <SelectWrapper
                      labelText='Responsable'
                      name='responsableId'
                      data={dataUser}
                      onChangeValue={handleGetReponsable}
                      disabled={dataUser.length === 0}
                    />
                  </div>

                  <div className='col-sm-12 col-md-4 col-xl-3'>
                    <InputDateWrapper labelText='Desde' name='fechaPeriodoInicio' required />
                  </div>
                  <div className='col-sm-12 col-md-4 col-xl-3'>
                    <InputDateWrapper labelText='Hasta' name='fechaPeriodoFin' required />
                  </div>
                </div>
                <ButtonWrapper className='sdx-white-bg ms-auto'>
                  <Button label='Buscar' disabled={searching} onClick={handleSubmit(onSubmit)} />
                  <Button label='Limpiar' onClick={() => handleResetForm()} />
                  {isAllowed('EXPORTAR') && <DrawerReport data={data} loading={isDownload} />}
                  {isAllowed('CREAR_REPORTE') && (
                    <Button label='Guardar Reporte' onClick={handleSubmit(handleOpenModal)} />
                  )}
                </ButtonWrapper>
              </form>
            </FormProvider>
          </div>
        )}
        <div className='sdx_content_tab_panel'>
          <Tabs className={'sdx_sub_react_tab_panel '}>
            <TabList className={'sdx_sub_tab_panel p-0'}>
              {isAllowed('HISTORIALPESOS/ACCESO') && (
                <Tab className={'sdx_sub_tab_panel_option'}>Historial de Pesos </Tab>
              )}
              {isAllowed('CECO/ACCESO') && (
                <Tab className={'sdx_sub_tab_panel_option'}>Centro de Costos</Tab>
              )}
            </TabList>
            {isAllowed('HISTORIALPESOS/ACCESO') && (
              <TabPanel>
                <TableLaundryHystoryWrapper search={formValue} />
              </TabPanel>
            )}
            {isAllowed('CECO/ACCESO') && (
              <TabPanel>
                <TableLaundryCostWrapper validation={responseCost} search={formValue} />
              </TabPanel>
            )}
          </Tabs>
        </div>
        <ModalSaveReport show={isOpenModal} setShow={setIsOpenModal} detail={detailReport} />
      </KTCard>
    </>
  )
}

const TableLaundryGenerateBillingWrapper = () => {
  return (
    <div>
      <TableLaundryGenerateBilling />
    </div>
  )
}

export {TableLaundryGenerateBillingWrapper}
